<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'H5App',
  data() {
    return {
      
    }
  },
}
</script>

<style lang="scss" scoped>
#app{
  height: 100vh;
  width: 100vw;
  position: relative;
}
*{
  margin: 0;
  padding: 0;
  list-style: none;
}
html{
  font-size: 16px;
  color: #333;
}
button{
  outline: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
input{
  background: none;
  border: none;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
}
img{
  margin: 0;
  padding: 0;
  font-size: 0;
}
</style>
